import type {
  GamificationRewardOutcome,
  GamificationRewardOutcomeStatus,
} from "@core/gamification/types";

/** Identifies one independently reported Gamification balance. */
export type RewardCurrencyKey = "xp" | "gold" | "leaguePoints";

/** Lists every balance reported by the shared reward acknowledgement. */
export const rewardCurrencyKeys: RewardCurrencyKey[] = [
  "xp",
  "gold",
  "leaguePoints",
];

/**
 * List every currency carrying one exact server-confirmed outcome status.
 *
 * @example
 * const capped = gamificationRewardCurrenciesWithStatus(outcomes, "capped");
 */
export function gamificationRewardCurrenciesWithStatus(
  outcomes: GamificationRewardOutcome[],
  status: GamificationRewardOutcomeStatus,
): RewardCurrencyKey[] {
  return rewardCurrencyKeys.filter((currency) =>
    outcomes.some((outcome) => outcome[currency].status === status),
  );
}
